import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID       = "G-1YNPJHHHLH";
const FB_PIXEL_ID = "212563324850714";

// Pages where tracking must NOT fire.
const isExcluded = (pathname) =>
    pathname.startsWith("/admin") || pathname.startsWith("/api-endpoint");

export default function TrackingScripts() {
    const { pathname } = useLocation();

    useEffect(() => {
        if (isExcluded(pathname)) return;

        // First non-excluded view this session: inject GA + Pixel into <head>.
        if (!window.__pxlTrackingInjected) {
            window.__pxlTrackingInjected = true;

            // Google Analytics (gtag.js)
            const gaLoader = document.createElement("script");
            gaLoader.async = true;
            gaLoader.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
            document.head.appendChild(gaLoader);

            const gaInit = document.createElement("script");
            gaInit.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                window.gtag = gtag;
                gtag('js', new Date());
                gtag('config', '${GA_ID}');
            `;
            document.head.appendChild(gaInit);

            // Facebook Pixel
            const fbInit = document.createElement("script");
            fbInit.innerHTML = `
                !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
                n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
                document,'script','https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '${FB_PIXEL_ID}');
                fbq('track', 'PageView');
            `;
            document.head.appendChild(fbInit);

            // noscript fallback (faithful to the snippet)
            const ns = document.createElement("noscript");
            ns.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1" />`;
            document.head.appendChild(ns);

            return; // initial injection already fires PageView for both vendors
        }

        // SPA navigation between non-excluded routes — re-fire page views.
        if (typeof window.gtag === "function") window.gtag("config", GA_ID);
        if (typeof window.fbq  === "function") window.fbq("track", "PageView");
    }, [pathname]);

    return null;
}
